import { Box } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { PlanFeedField } from './PlanFeedField'

import { isFactWeightDeviation } from './feedPlanDeviation'
import FactTimeValue from './FactTimeValue'
import { PlanFeedFieldName } from '../../models'
import { IFeedTableProps } from '../../models/IFeed'
import { COLORS } from '../../styles/colors'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'

const ViewPlanListCleaning = (props: IFeedTableProps) => {
	type columnsType = {
		name: string
		title: string
		align: 'center' | 'right' | 'left' | 'inherit' | 'justify'
	}

	const columns: columnsType[] = [
		{ name: 'group', title: 'Группа', align: 'left' },
		{ name: 'time_plan', title: 'Плановое время', align: 'right' },
		{ name: 'time_fact', title: 'Фактическое время', align: 'right' },
		{ name: 'balance', title: 'Остаток', align: 'center' },
	]

	return (
		<Box sx={{ pt: '24px' }}>
			<TableContainer sx={{ p: '0px 24px 12px 18px' }}>
				<Table
					sx={{
						minWidth: 650,
						[`& .${tableCellClasses.root}`]: {
							borderBottom: 'none',
						},
					}}
					aria-label='simple table'
				>
					<TableHead>
						<TableRow
							sx={{ borderBottom: `1px solid ${COLORS.secondaryFontOpacity}` }}
						>
							{columns.map((tableCol, index) => (
								<TableCell
									sx={{
										fontSize: '12px',
										lineHeight: '15px',
										color: COLORS.icon,
										pl:
											tableCol.name === 'balance'
												? '120px'
												: tableCol.name === 'group'
													? '8px'
													: '',
									}}
									align={tableCol.align}
									key={index}
								>
									<TypographySecondary>{tableCol.title}</TypographySecondary>
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{props.groupsArray.map((el, index) => {
							const weightDeviation = isFactWeightDeviation(
								el,
								props.feedPlanDate,
								props.deviation,
								el.plan_time,
							)
							return (
								<TableRow sx={{}} key={index}>
									<TableCell
										component='th'
										scope='row'
										align='left'
										sx={{ paddingLeft: '8px' }}
									>
										<Box
											display='flex'
											flexDirection='row'
											alignItems='baseline'
										>
											{el.group.title}
											<TypographySecondary sx={{ pl: '4px' }}>
												{el.group.barn.title}
											</TypographySecondary>
										</Box>
									</TableCell>
									<TableCell
										align='center'
										sx={{ textAlign: 'right', pr: '48px' }}
									>
										{el.plan_time}
									</TableCell>
									<TableCell align='right'>
										<Box display='flex' justifyContent='flex-end'>
											<FactTimeValue
												factDt={el.fact_dt}
												planTime={el.plan_time}
												date={props.feedPlanDate}
												deviation={props.deviation}
											/>
										</Box>
									</TableCell>
									<TableCell
										align='right'
										key={`viewPlanListCleaningTableCellWeight${props.uniqueKey}`}
									>
										<Box
											sx={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-end',
												gap: '8px',
											}}
										>
											<PlanFeedField
												isFutureDate={props.isFuture}
												factDt={el.fact_dt}
												type='number'
												label={'кг'}
												key={`viewPlanFeedFieldWeight${props.uniqueKey}`}
												feedPlanDate={props.feedPlanDate}
												value={el.weight}
												groupId={el.group.id}
												planId={props.planId}
												fieldName={PlanFeedFieldName.WEIGHT}
												metaFlags={el.has_fact_data_demand}
												hasWeightDeviation={weightDeviation}
											/>
										</Box>
									</TableCell>
								</TableRow>
							)
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}

export default ViewPlanListCleaning
